import React from 'react';
import { motion } from 'framer-motion';
import phoneImage from '../assets/features/spam-caller.png'; // latest phone image
import { useTranslation } from 'react-i18next'; // Import useTranslation

const TrustSection: React.FC = () => {
  const { t } = useTranslation(); // Initialize useTranslation hook

  return (
    <section className="w-full py-16 px-6 md:px-12 lg:px-24  relative">
      <div className="relative min-h-[400px] z-10 bg-gradient-to-br from-blue-700 to-green-600 text-white rounded-3xl px-8 py-12 flex flex-col lg:flex-row items-center justify-between shadow-xl"> {/* Changed h-[400px] to min-h-[400px] */}

        {/* LEFT - Text Content */}
        <motion.div
          className="lg:w-1/2 text-center lg:text-left"
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <span className="inline-block bg-white text-[#0a2540] text-xs font-bold px-3 py-1 rounded-full mb-4 tracking-wider">
            {t('trust_insights_label')} {/* Translated */}
          </span>
          <h2 className="text-3xl md:text-4xl font-bold leading-tight mb-4">
            {t('trust_heading')} {/* Translated */}
          </h2>
          <p className="text-md md:text-lg opacity-80 mb-6">
            {t('trust_description')} {/* Translated */}
          </p>
          <a
            href="#"
            className="inline-block border border-white px-6 py-3 rounded-xl text-sm font-semibold hover:bg-white hover:text-[#0a2540] transition duration-300"
          >
            {t('read_report_button')} {/* Translated */}
          </a>
        </motion.div>

        {/* RIGHT - Phone with Glowing Animation */}
        <motion.div
          className="lg:w-1/2 mt-12 lg:mt-0 flex justify-center relative"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          {/* Glowing Ring */}
          <div className="absolute w-[200px] h-[200px] md:w-[280px] md:h-[280px] rounded-full bg-blue-500 blur-3xl opacity-30 animate-ping z-0" />

          {/* Phone Image */}
          <img
            src={phoneImage}
            alt={t('trust_phone_alt')}
            className="relative z-10 w-[200px] md:w-[260px] lg:w-[350px] object-contain"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default TrustSection;